import type { EmbarcacaoSistemasDpField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const SISTEMAS_DP_ID = "sistemas-dp";
export const SISTEMAS_DP_TITLE = "Sistemas de DP";
/** Título da seção no Figma ("Sistemas e DP"); o menu e a aba seguem o rótulo da HU. */
export const SISTEMAS_DP_SECTION_TITLE = "Sistemas e DP";
export const SISTEMAS_DP_TEST_ID = "embarcacao-sistemas-dp";
export const SISTEMAS_DP_LOADING_MESSAGE = "Carregando os Sistemas de DP da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const SISTEMAS_DP_EMPTY_STATE = {
  title: "Nenhuma informação de Sistemas de DP disponível",
  description:
    "Assim que houver informações de DP para esta embarcação, elas aparecerão nesta seção.",
};

/** Os 5 campos, na ordem e nas colunas do protótipo. */
export const SISTEMAS_DP_FIELDS: DetailFieldDefinition<EmbarcacaoSistemasDpField>[] = [
  { key: "dp", label: "DP" },
  { key: "fabricanteModelo", label: "Fabricante e Modelo" },
  { key: "sistemaReferenciaRelativo1", label: "Sistema Referência Relativo 1" },
  { key: "sistemaReferenciaRelativo2", label: "Sistema Referência Relativo 2" },
  { key: "atualizacaoDp", label: "Data Atualização DP", format: formatDetailDate },
];
